import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import UpgradeRequired from './Upgrade/UpgradeGate'
import API from '../services/API'

const UpgradeBoundary = ({ setUpgradeRequired, upgradeRequired, children }) => {
  const navigate = useNavigate()

  return (
    <>
      <UpgradeRequired
        featureName={upgradeRequired.featureName}
        requiredTier={upgradeRequired.requiredTier}
        open={!!upgradeRequired}
        onClose={setUpgradeRequired}
        benefits={upgradeRequired.benefits}
      />
      {children}
    </>
  )
}

export default UpgradeBoundary
